var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.moduleData.gif)?_c('div',{staticClass:"usp-app-map",attrs:{"data-ani":"aniGroup"}},[_c('div',{staticClass:"usp-app-map-gif"},[_c('img',{attrs:{"src":_vm.moduleData.gif,"alt":""}})])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }